import { useEffect, useState } from 'react'

/** 'YYYY-MM-DD' no calendário local (sem passar por UTC). */
export function isoLocal(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export const hojeISO = () => isoLocal(new Date())
export const primeiroDoMes = () => { const d = new Date(); return isoLocal(new Date(d.getFullYear(), d.getMonth(), 1)) }
export const primeiroDoMesPassado = () => { const d = new Date(); return isoLocal(new Date(d.getFullYear(), d.getMonth() - 1, 1)) }

/** 'YYYY-MM-DD...' -> 'DD/MM'. */
export function diaMes(iso: string): string {
  const [, m, d] = iso.slice(0, 10).split('-')
  return `${d}/${m}`
}

/** 'YYYY-MM-DD...' -> 'DD/MM/YYYY'. */
export function diaMesAno(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-')
  return `${d}/${m}/${y}`
}

/** Aceita vírgula decimal. Vazio ou inválido = null. */
export function lerValor(texto: string): number | null {
  const t = texto.trim().replace(',', '.')
  if (!t) return null
  const n = Number(t)
  return Number.isFinite(n) ? n : null
}

export function useDebounced<T>(valor: T, ms = 500): T {
  const [v, setV] = useState(valor)
  useEffect(() => {
    const t = setTimeout(() => setV(valor), ms)
    return () => clearTimeout(t)
  }, [valor, ms])
  return v
}
